module.exports = __webpack_public_path__ + "img/trading-view-dark.372a8b7d.png";